import axios, { AxiosError } from "axios";
import { useQuery } from "react-query";
import { EmployeeImportJobWrapper } from "../model/EmployeeImportJob";
import EmployeeImportJobListApiRequest from "../request/EmployeeImportJobListApiRequest";

const EmployeeImportJobListApiService = async (
  request: EmployeeImportJobListApiRequest
): Promise<EmployeeImportJobWrapper> => {
  const url = "/employeeimportjob";
  const { data } = await axios.get(url, { params: request });

  return data;
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useEmployeeImportJobListApiService = (
  request: EmployeeImportJobListApiRequest
) =>
  useQuery<
    Promise<EmployeeImportJobWrapper>,
    AxiosError,
    EmployeeImportJobWrapper
  >(["EmployeeImportJobListApiService", request.page], () =>
    EmployeeImportJobListApiService(request)
  );

export default useEmployeeImportJobListApiService;
